<template>
<div class="mobile-wrap">
  <div class="wrapper" id="app">
    <div class="card-form">
      <div class="card-list">
        <div class="card-item" v-bind:class="{ '-active' : isCardFlipped }">
          <div class="card-item__side -front">
            <div class="card-item__focus" v-bind:class="{'-active' : focusElementStyle }" v-bind:style="focusElementStyle" ref="focusElement"></div>
            <div class="card-item__cover">
              <img  :src="identifyMemberCard.memberLink" class="card-item__bg" style="transform: scale(1.075) translateY(0%) translateX(0px); ">
              <!-- <img v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + currentCardBackground + '.jpeg'" class="card-item__bg"> -->
            </div>

            <div class="card-item__wrapper">
              <div class="card-item__top">
                <!-- <img src="https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/chip.png" class="card-item__chip"> -->
                <!-- <div class="card-item__type">
                  <transition name="slide-fade-up">
                    <img v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + getCardType + '.png'" v-if="getCardType" v-bind:key="getCardType" alt="" class="card-item__typeImg">
                  </transition>
                </div> -->
              </div>
              <label for="cardNumber" class="card-item__number" ref="cardNumber">
                <template v-if="getCardType === 'amex'">
                 <span v-for="(n, $index) in amexCardMask" :key="$index">
                  <transition name="slide-fade-up">
                    <div
                      class="card-item__numberItem"
                      v-if="$index > 4 && $index < 14 && cardNumber.length > $index && n.trim() !== ''"
                    >*</div>
                    <div class="card-item__numberItem"
                      :class="{ '-active' : n.trim() === '' }"
                      :key="$index" v-else-if="cardNumber.length > $index">
                      {{cardNumber[$index]}}
                    </div>
                    <div
                      class="card-item__numberItem"
                      :class="{ '-active' : n.trim() === '' }"
                      v-else
                      :key="$index + 1"
                    >{{n}}</div>
                  </transition>
                </span>
                </template>

                <template v-else>
                  <div style="letter-spacing:2px; margin-top: 10px;" :style="{color: colorSwitch()}">{{eid}}</div>
                  <!-- <span v-for="(n, $index) in otherCardMask" :key="$index">
                    <transition name="slide-fade-up">
                      <div
                        class="card-item__numberItem"
                        v-if="$index > 4 && $index < 15 && cardNumber.length > $index && n.trim() !== ''"
                      >*</div>
                      <div class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        :key="$index" v-else-if="cardNumber.length > $index">
                        {{cardNumber[$index]}}
                      </div>
                      <div
                        class="card-item__numberItem"
                        :class="{ '-active' : n.trim() === '' }"
                        v-else
                        :key="$index + 1"
                      >{{n}}</div>
                    </transition>
                  </span> -->
                </template>
              </label>
              <div class="card-item__content">
                <label for="cardName" class="card-item__info" ref="cardName">
                  <div class="card-item__holder" :style="{color: colorSwitch()}">Card Holder</div>
                  <transition name="slide-fade-up">
                    <!-- <div class="card-item__name" v-if="cardName.length" key="1">
                      <transition-group name="slide-fade-right">
                        <span class="card-item__nameItem" v-for="(n, $index) in cardName.replace(/\s\s+/g, ' ')"  v-bind:key="$index + 1">{{n}}</span>
                      </transition-group>
                    </div> -->
                    <div class="card-item__name" key="2" :style="{color: colorSwitch()}">{{ user }}</div>
                  </transition>
                </label>
                <div class="card-item__date" ref="cardDate" >
                  <label for="cardMonth" class="card-item__dateTitle" :style="{color: colorSwitch()}">Points</label>
                  <label for="cardMonth" class="card-item__dateItem">
                    <transition name="slide-fade-up">
                      <div :style="{color: colorSwitch()}">{{ eilisProfile.point ? eilisProfile.point : points }}</div>
                      <!-- <span v-else key="2">MM</span> -->
                    </transition>
                  </label>
                  <!-- <label for="cardYear" class="card-item__dateItem">
                    <transition name="slide-fade-up">
                      <span >{{ points }}</span>
                      <span v-else key="2">YY</span>
                    </transition>
                  </label> -->
                </div>
                <div class="card-item__status" :style="{color: colorSwitch()}">
                  <div>Status</div>
                  <div class="card-item__statusItem" >{{status()}}</div>
                  <!-- <div v-if="memberClass === 'TXXX' || memberClass === 'AXXX'" class="card-item__statusItem">Member</div>
                  <div v-if="memberClass === 'TXVV' || memberClass === 'AXVV'" class="card-item__statusItem">VIP</div>
                  <div v-if="memberClass === 'AXBL'" class="card-item__statusItem">Blue</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="qrcode">
    <br>
    <div v-if="selectedCode === '1'" style="text-align: center; padding: 15px; border: 1px solid #eee; width: 90%; margin: 0 auto; margin-top: 0;">
      <qrcode-vue :value="qrCode" size="155" level="H"></qrcode-vue>
    </div>
    <div v-if="selectedCode === '2'" style="text-align: center;
    justify-content: space-between;
    display: flex;padding: 15px; border: 1px solid #eee; width: 90%; margin: 0 auto; height: 175px; transform: scale(1.4);">
      <img :src="barCode" width="100%"/>
    </div>
    <div style=" display: flex; justify-content: center;">
      <div class="containerbtn" style="top: 20px;">
      <div class="radio-tile-group">
        <!-- <div class="input-container" @click="popQr">
          <input id="bike" class="radio-button" type="radio" name="radio" />
          <div class="radio-tile">
            <div class="icon bike-icon">
              <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none"/>
                <path d="M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"/>
              </svg>
            </div>
            <label for="bike" class="radio-tile-label">二維碼</label>
          </div>
        </div> -->

        <!-- <div class="input-container" @click="popBar">
          <input id="drive" class="radio-button" type="radio" name="radio" />
          <div class="radio-tile">
            <div class="icon car-icon">
              <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                <path d="M0 0h24v24H0z" fill="none"/>
              </svg>
            </div>
            <label for="drive" class="radio-tile-label">ㄧ維碼</label>
          </div>
        </div> -->
      </div>
    </div>
    </div>
    <!-- <div style=" display: flex; justify-content: center;">
      <button  class="button" >用戶名稱:{{ user }}</button>
      <button  class="button">目前點數:{{ points }}</button>
    </div> -->
  </div>
  <div id="layer" v-if="noneInfo">
    <div class="info">
      <br>
      <div class="list">
      <div class="item" style="text-align:center;">
        <div class="left"></div>
        <div class="middle" style="margin-left: 20px;">最後一步</div>
        <div class="right"><i class="cubeic-close" style="margin-left: -40px;" @click="closeDia"/></div>
      </div>
      </div>
      <!-- 輸入縣市 -->
      <!-- <cube-select  id="info1" class="item"  title="請選擇" :options="option"  v-model="county"  :placeholder="option ? option[0] : ''" >
      </cube-select>
      <cube-select  class="item" title="請選擇" :options="options" v-model="district" placeholder="請選擇地區">
      </cube-select> -->
      <cube-form :model="model" :immediate-validate="false" @validate="validateHandler">
        <cube-form-group>
          <cube-form-item style="border: 1px solid #eee; width: 90%; margin: 0 auto;" :field="fields[0]" title="請選擇"></cube-form-item>
          <br>
          <cube-form-item style="border: 1px solid #eee; width: 90%; margin: 0 auto;" :field="fields[1]" title="請選擇"></cube-form-item>
        </cube-form-group>
      </cube-form>
      <!-- 輸入住址 -->
      <!-- <cube-input   class="item"               v-model="address" placeholder="輸入住址" ></cube-input> -->
      <br><br>
      <cube-button :primary="true" style="width: 89%; margin: 0 auto;" :outline="true" @click="updateUserInfo">確認</cube-button>
    </div>
  </div>
  <!-- <div class="container">
    <ul class="list">
      <div class="item">
        <div class="left">
          <li class="title">店家查詢</li>
          <li class="entitle">SEARCHING SHOP</li>
        </div>
        <div class="right">123</div>
      </div>
      <div class="item">
        <div class="left">
          <li class="title">現在下單</li>
          <li class="entitle">ORDER NOW</li>
        </div>
        <div class="right">123</div>
      </div>
    </ul>
  </div> -->
</div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions, createNamespacedHelpers} from 'vuex'
import QrcodeVue from 'qrcode.vue';
import VueBarcode from 'vue-barcode';
// import VueBarcode from 'vue-barcode';

const region = {
    '基隆市':['仁愛區', '信義區', '中正區', '中山區', '安樂區', '暖暖區', '七堵區'],
    '台北市':["中正區","大同區","中山區","大安區","松山區","萬華區","信義區","士林區","北投區","內湖區","南港區","文山區"],
    '新北市':["板橋區","永和區","中和區","汐止區","土城區","林口區","三芝區","淡水區","八里區","五股區","蘆洲區","新莊區","泰山區","三峽區","石門區","三重區","鶯歌區","樹林區","新店區","金山區","萬里區","烏來區","坪林區","深坑區","石碇區","瑞芳區","平溪區","雙溪區","貢寮區"],
    '宜蘭縣':['宜蘭市', '頭城鎮', '礁溪鄉', '壯圍鄉', '員山鄉', '羅東鎮', '三星鄉', '大同鄉', '五結鄉', '冬山鄉', '蘇澳鎮', '南澳鄉'],
    '桃園市':['中壢區', '平鎮區', '龍潭區', '楊梅區', '新屋區', '觀音區', '桃園區', '龜山區', '八德區', '大溪區', '復興區', '大園區', '蘆竹區'],
    '新竹市':['東區', '北區', '香山區'],
    '新竹縣':['竹北市', '湖口鄉', '新豐鄉', '新埔鎮', '關西鎮', '芎林鄉', '寶山鄉', '竹東鎮', '五峰鄉', '橫山鄉', '尖石鄉', '北埔鄉', '峨眉鄉'],
    '苗栗縣':['竹南鎮', '頭份鎮', '三灣鄉', '南庄鄉', '獅潭鄉', '後龍鎮', '通霄鎮', '苑裡鎮', '苗栗市', '造橋鄉', '頭屋鄉', '公館鄉', '大湖鄉', '泰安鄉', '銅鑼鄉', '三義鄉', '西湖鄉', '卓蘭鎮'],
    '台中市':['中區', '東區', '南區', '西區', '北區', '北屯區', '西屯區', '南屯區', '太平區', '大里區', '霧峰區', '烏日區', '豐原區', '后里區', '石岡區', '東勢區', '和平區', '新社區', '潭子區', '大雅區', '神岡區', '大肚區', '沙鹿區', '龍井區', '梧棲區', '清水區', '大甲區', '外埔區', '大安區'],
    '彰化縣':['彰化市', '芬園鄉', '花壇鄉', '秀水鄉', '鹿港鎮', '福興鄉', '線西鄉', '和美鎮', '伸港鄉', '員林鎮', '社頭鄉', '永靖鄉', '埔心鄉', '溪湖鎮', '大村鄉', '埔鹽鄉', '田中鎮', '北斗鎮', '田尾鄉', '埤頭鄉', '溪州鄉', '竹塘鄉', '二林鎮', '大城鄉', '芳苑鄉', '二水鄉'],
    '南投縣':["南投市","中寮鄉","草屯鎮","國姓鄉","埔里鎮","仁愛鄉","名間鄉","集集鎮","水里鄉","魚池鄉","信義鄉","竹山鎮","鹿谷鄉"],
    '雲林縣':["斗南鎮","大埤鄉","虎尾鎮","土庫鎮","褒忠鄉","東勢鄉","台西鄉","崙背鄉","麥寮鄉","斗六市","林內鄉","古坑鄉","莿桐鄉","西螺鎮","二崙鄉","北港鎮","水林鄉","口湖鄉","四湖鄉","元長鄉"],
    '嘉義市':['西區', '東區'],
    '嘉義縣':['番路鄉', '梅山鄉', '竹崎鄉', '阿里山鄉', '中埔鄉', '大埔鄉', '水上鄉', '鹿草鄉', '太保市', '朴子市', '東石鄉', '六腳鄉', '新港鄉', '民雄鄉', '大林鎮', '溪口鄉', '義竹鄉', '布袋鎮'],
    '台南市':['北區','東區','南區','中西區',"永康區","歸仁區","新化區","左鎮區", "安南區","安平區","玉井區","楠西區","南化區","仁德區","關廟區","龍崎區","官田區","麻豆區","佳里區","西港區","七股區","將軍區","學甲區","北門區","新營區","後壁區","白河區","東山區","六甲區","下營區","柳營區","鹽水區","善化區","大內區","山上區","新市區","安定區"],
    '高雄市':['新興區', '前金區', '苓雅區', '鹽埕區', '鼓山區', '旗津區', '前鎮區', '三民區', '楠梓區', '小港區', '左營區', '仁武區', '大社區', '岡山區', '路竹區', '阿蓮區', '田寮區', '燕巢區', '橋頭區', '梓官區', '彌陀區', '永安區', '湖內區', '鳳山區', '大寮區', '林園區', '鳥松區', '大樹區', '旗山區', '美濃區', '六龜區', '內門區', '杉林區', '甲仙區', '桃源區', '那瑪夏區', '茂林區', '茄萣區'],
    '屏東縣':['屏東市', '三地門鄉', '霧台鄉', '瑪家鄉', '九如鄉', '里港鄉', '高樹鄉', '鹽埔鄉', '長治鄉', '麟洛鄉', '竹田鄉', '內埔鄉', '萬丹鄉', '潮州鎮', '泰武鄉', '來義鄉', '萬巒鄉', '崁頂鄉', '新埤鄉', '南州鄉', '林邊鄉', '東港鎮', '琉球鄉', '佳冬鄉', '新園鄉', '枋寮鄉', '枋山鄉', '春日鄉', '獅子鄉', '車城鄉', '牡丹鄉', '恆春鎮', '滿州鄉'],
    '台東縣':['台東市','綠島鄉', '蘭嶼鄉', '延平鄉', '卑南鄉', '鹿野鄉', '關山鎮', '海端鄉', '池上鄉', '東河鄉', '成功鎮', '長濱鄉', '太麻里鄉', '金峰鄉', '大武鄉', '達仁鄉'],
    '花蓮縣':['花蓮市', '新城鄉', '秀林鄉', '吉安鄉', '壽豐鄉', '鳳林鎮', '光復鄉', '豐濱鄉', '瑞穗鄉', '萬榮鄉', '玉里鎮', '卓溪鄉', '富里鄉'],
    '金門縣':['金沙鎮', '金湖鎮', '金寧鄉', '金城鎮', '烈嶼鄉', '烏坵鄉'],
    '連江縣':['南竿鄉', '北竿鄉', '莒光鄉', '東引鄉'],
    '澎湖縣':['馬公市', '西嶼鄉', '望安鄉', '七美鄉', '白沙鄉', '湖西鄉']
}
const CryptoJS = require('crypto-js');
// console.log(CryptoJS);
export default {
  data () {
    return {
      // 信用卡
      getCardType:'',
      currentCardBackground: Math.floor(Math.random()* 25 + 1), // just for fun :D
      cardName: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cardCvv: "",
      minCardYear: new Date().getFullYear(),
      // amexCardMask: "#### ###### #####" || this.eid,
      // otherCardMask: this.eid ,
      cardNumberTemp: "",
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false,
      // 信用卡
      model: {
        county: '',
        district: '',
        checkboxValue: false,
        checkboxGroupValue: [],
        inputValue: '',
        radioValue: '',
        rateValue: 0,
        selectValue: '選擇縣市',
        switchValue: true,
        textareaValue: '',
        uploadValue: []
      },
      fields: [
        {
          type: 'select',
          modelKey: 'county',
          label: '縣市',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請選擇縣市',
            options: Object.keys(region),
          },
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'district',
          label: '區域',
          props: {
            confirmTxt: '確定',
            title: '請選擇',
            placeholder: '請選擇鄉鎮區域',
            options: [],
          },
          rules: {
            required: true
          }
        },
      ],
      address: '',
      chosen: '',
      noneInfo: false,
      selectedCode: '1',
      channelData: {
        AuthToken: this.$route.query.Auth,
        Service: this.$route.params.service,
        PhoneNumber: '',
        Name: this.$route.query.Name ? this.$route.query.Name : '',
        PageID: this.$route.query.Page,
      },
    }
  },
  props: ['qrCode','barCode', 'points', 'user', 'eid', 'memberClass'],
  components: {
    QrcodeVue,
    VueBarcode
  },
  mounted() {
    // this.memberClass = 'AXBL'
    // setTimeout(() => {
    //   console.log(this.user);
    //   console.log(this.memberClass);
    // },1500)
    // console.log(this.memberClass);
    // console.log(this.eilisProfile);
    // console.log(this.infomation.brand);
    // console.log(this.memberClass);
    // setTimeout(() => {
    //   console.log(this.memberClass);
    // },500)
    // this.getUser();
    // this.chosen = region[this.model.county]
  },
  watch: {
    countySelect(val) {
      this.fields[1].props.options = region[this.model.county];
    },
    memberClass(val) {
      // console.log(val);
      if (val === 'TXXX') {
        this.identifyMemberCard.memberLink = require('../img/whittard_Gen.jpg');
      } else if (val === 'TXVV') {
        this.identifyMemberCard.memberLink = require('../img/whittard_Vip.jpg');
      } else if (val === 'AXXX') {
        // console.log('2');
        this.identifyMemberCard.memberLink = require('../img/EP_AXXX-01.png')
        // console.log(this.identifyMemberCard);
      } else if (val === 'AXVV') {
        this.identifyMemberCard.memberLink = require('../img/EP_AXVV-02.png')
      } else if (val === 'AXBL') {
        // console.log('1');
        this.identifyMemberCard.memberLink = require('../img/EP_AXBL-03.png')
      } else if (val === '7XXX' || val === '8XXX') {
        // console.log('1');
        this.identifyMemberCard.memberLink = require('../img/JEEP-G.jpg')
      } else if (val === 'XX7V' || val === 'XX8V') {
        // console.log('1');
        this.identifyMemberCard.memberLink = require('../img/JEEP-V.jpg')
      } else if (val === '1XXX') {
        this.identifyMemberCard.memberLink = require('../img/Nautica-G.jpg')
      } else if (val === 'XXVV') {
        this.identifyMemberCard.memberLink = require('../img/Nautica-V.jpg')
      } else if (val === 'XXFF') {
        this.identifyMemberCard.memberLink = require('../img/Nautica-F.jpg')
      } else if (val === 'VXXX' || val === 'VXVV' || val === 'XXAZ') {
        this.identifyMemberCard.memberLink = require('../img/LIP-Card.jpg')
      }
    }
  },
  computed: {
    ...mapGetters({
      infomation: 'infomation',
      eilisProfile: 'eilisProfile'
    }),
    identifyMemberCard: {
      get () { return this.eilisProfile },
      set(value) { this.storeEilisFile({ Efile: value }); },
    },
    // identifyMember() {
    //   if (this.memberClass === 'TXXX') {
    //     this.identifyMemberCard = "../img/whittard_Gen.jpg" ;
    //   } else if (this.memberClass === 'TXVV') {
    //     this.identifyMemberCard = "../img/whittard_Vip.jpg" ;
    //   } else if (this.memberClass === 'AXXX') {
    //     this.identifyMemberCard = "../img/EP_AXXX-01.png"
    //   } else if (this.memberClass === 'AXVV') {
    //     this.identifyMemberCard = "../img/EP_AXVV-02.png"
    //   } else if (this.memberClass === 'AXBL') {
    //     console.log('1');
    //     this.identifyMemberCard = "../img/EP_AXBL-03.png"
    //   }
    // },
    countySelect() {
      return this.model.county;
    }
  },
  methods: {
  ...mapActions({
    getUserData: 'getUserData',
    getAccessToken: 'getAccessToken',
    getUserOrder: 'getUserOrder',
    updateInfo: 'updateInfo',
  }),
  colorSwitch() {
    if (this.memberClass === 'TXXX') {
      return '#415866';
    } else if (this.memberClass === 'AXXX' || this.memberClass === 'AXVV' || this.memberClass === '1XXX') {
      return '#000021';
    } else if (this.memberClass === '7XXX' || this.memberClass === '8XXX') {
      return '#000000';
    } else if (this.memberClass === 'XX8V' || this.memberClass === 'XX7V') {
      return '#f7f7f7';
    } else if (this.memberClass === 'VXXX' || this.memberClass === 'VXVV' || this.memberClass === 'XXAZ') {
      return '#000000';
    }
    // color: infomation.brand === 'Whittard' && memberClass === 'TXXX' ? '#415866' :  memberClass === 'AXXX' || memberClass === 'AXVV' ? '#000021' : ''}
  },
  status() {
    if (this.memberClass === '1XXX' || this.memberClass === 'TXXX' || this.memberClass === 'AXXX' || this.memberClass === '7XXX' || this.memberClass === '8XXX' || this.memberClass === 'VXXX') {
      return 'Member';
    } else if (this.memberClass === 'XXVV' || this.memberClass === 'TXVV' || this.memberClass === 'AXVV' || this.memberClass === 'XX7V' || this.memberClass === 'XX8V' || this.memberClass === 'VXVV') {
      return 'VIP';
    } else if (this.memberClass === 'AXBL') {
      return 'Blue';
    } else if (this.memberClass === 'XXFF') {
      return 'F卡';
    } else if (this.memberClass === 'XXAZ') {
      return 'GOLD';
    }
  },
  transform(val) {
    if (this.infomation.brand === 'Whittard' && this.memberClass === 'TXXX') {
      return '#415866';
    } else if (this.memberClass === 'AXXX' || this.memberClass === 'AXVV') {
      return '#000021';
    } else if (this.memberClass === '7XXX' || this.memberClass === '8XXX' || this.memberClass === 'XX7V' || this.memberClass === 'XX8V') {
      return 'white';
    }
  },
  closeDia() {
    this.noneInfo = false;
  },
  validateHandler(result) {
    // console.log(this.model.county);
    // console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    //this.fields[1].props.options = region[this.model.county];
  },
  updateUserInfo() {
    // this.loading = true;
    if (this.model.county === '' || this.model.district === '') {
      this.$createDialog({
        type: 'alert',
        title: '小提示',
        content: '鄉鎮市未填喔！',
        icon: 'cubeic-alert',
        confirmBtn: {
          text: '確定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
      }).show()
      // this.loading = false;
      return;
    }
    // console.log(this.model.county + this.model.district);
    // return;
    this.getAccessToken({time: Date.now()})
    .then((res) => {
      // console.log(res);
      this.updateInfo({ access: res.data.access_token ,service: this.channelData.Service, authToken: this.channelData.AuthToken, address: this.model.county + this.model.district, })
      this.noneInfo = false;
      // this.loading = false;
    })
  },
  // 解密
  Decrypt(word) {
    // console.log(word);
    var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv1"
    var iv = "N6lRbzhhbyHgiU66"
    const keysStr = CryptoJS.enc.Utf8.parse(key);
    const ivStr = CryptoJS.enc.Utf8.parse(iv);
    let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, keysStr, {
        iv: ivStr,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    // console.log(decryptedStr);
    return decryptedStr.toString();
  },
  popQr() {
    this.selectedCode = '1';
  },
  popBar() {
    this.selectedCode = '2';
  },
  }
}
</script>

<style lang="scss" scoped>
    @import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:400,500,600,700|Source+Sans+Pro:400,600,700&display=swap");

body {
  background: #ddeefc;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
}
* {
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
}
  #layer{
    z-index: 20;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.6);
    overflow-y: hidden !important;
  }
.info {
  // border: 1px solid rgb(211, 211, 211);
  border-radius: 0px;
  z-index: 1000;
  width: 80%;
  margin: 0 auto;
  z-index: 10000;
  text-align: left;
  background-color: #ffffff;
  margin-top: 130px;
  height: 300px;
  font-size: 0.5cm;
  border-radius: 3px;
  overflow-y: auto;
  // transform:translate(-50%,-50%);
  animation: bomaction 0.15s linear forwards;
  // transform: rotate(0deg); // fix 子元素超出边框圆角部分不隐藏的问题
}
@keyframes bomaction {
  0% {
    -webkit-transform: scale(0.1)  rotate(0deg);
            transform: scale(0.1)  rotate(0deg);
    top:0%;
  }
  46% {
    top:52%;
  }
  48% {
    top:48%;
  }
  50% {
    -webkit-transform: scale(0.5)  rotate(0deg);
            transform: scale(0.5)  rotate(0deg);
    top:52%;
  }
  54% {
    top:52%;
  }
  56% {
    top:48%;
  }
  57% {
    -webkit-transform: scale(0.9)  rotate(0deg);
            transform: scale(0.9)  rotate(0deg);
    top:48%;
  }
  75% {
    -webkit-transform: scale(0.95)  rotate(0deg);
            transform: scale(0.95)  rotate(0deg);
    top:48%;
  }
  90% {
    -webkit-transform: scale(1.15)  rotate(0deg);
            transform: scale(1.15)  rotate(0deg);
    top:48%;
  }
  100% {
    -webkit-transform: scale(1) translateX(0px) rotate(0deg);
            transform: scale(1) translateX(0px) rotate(0deg);
    top:50%;
  }
}
.wrapper {
  min-height: 15vh;
  display: flex;
  padding: 20px 15px;
  @media screen and (max-width: 700px), (max-height: 500px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
}
.card-item__wrapper {
  top: 50px;
  position: relative;
  left: -30px;
}
.card-item__name {
  //transform: translateX(20px);
  margin-left: -30px;
}
.card-form {
  max-width: 580px;
  margin: auto;
  // min-width: 350px;
  width: 100%;

  @media screen and (max-width: 576px) {
    margin: 0 auto;
  }

  &__inner {
    background: #fff;
    // box-shadow: 3px 13px 30px 0px rgba(21, 34, 67, 0.2);
    box-shadow: 0 30px 30px 0 rgba(90, 116, 148, 0.4);
    border-radius: 10px;
    padding: 35px;
    padding-top: 180px;

    @media screen and (max-width: 480px) {
      padding: 25px;
      padding-top: 165px;
    }
    @media screen and (max-width: 360px) {
      padding: 15px;
      padding-top: 165px;
    }
  }

  &__row {
    display: flex;
    align-items: flex-start;
    @media screen and (max-width: 480px) {
      flex-wrap: wrap;
    }
  }

  &__col {
    flex: auto;
    margin-right: 35px;

    &:last-child {
      margin-right: 0;
    }

    @media screen and (max-width: 480px) {
      margin-right: 0;
      flex: unset;
      width: 100%;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &.-cvv {
      max-width: 150px;
      @media screen and (max-width: 480px) {
        max-width: initial;
      }
    }
  }

  &__group {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    .card-input__input {
      flex: 1;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__button {
    width: 100%;
    height: 55px;
    background: #2364d2;
    border: none;
    border-radius: 5px;
    font-size: 22px;
    font-weight: 500;
    font-family: "Source Sans Pro", sans-serif;
    box-shadow: 3px 10px 20px 0px rgba(35, 100, 210, 0.3);
    color: #fff;
    margin-top: 20px;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      margin-top: 10px;
    }
  }
}

.card-item {
  max-width: 450px;
  height: 270px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 2;
  width: 100%;

  .card-item__cover{
    background-position: top center;
    // background-image: url('../img/Louisablack.png');
    // transform: rotateY(-180deg)
  }
  .card-item__bg {
    background-position: top center;
    // background-image: url('../img/blackcard.png');
    // background: url('../img/blackcard.png');
    // background-position: center;
    // // background-size: 300px 400px;
    // transform: scale(5);
  }
  @media screen and (max-width: 480px) {
    max-width: 410px;
    height: 235px;
    width: 100%;
  }
  @media screen and (max-width: 400px) {
    height: 210px;
  }
  @media screen and (max-width: 360px) {
    height: 180px;
  }

  &.-active {
    .card-item__side {
      &.-front {
        transform: perspective(1000px) rotateY(180deg) rotateX(0deg)
          rotateZ(0deg);
      }
      &.-back {
        transform: perspective(1000px) rotateY(0) rotateX(0deg) rotateZ(0deg);
        // box-shadow: 0 20px 50px 0 rgba(81, 88, 206, 0.65);
      }
    }
  }

  &__focus {
    position: absolute;
    z-index: 3;
    border-radius: 5px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: all 0.35s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    opacity: 0;
    pointer-events: none;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.65);

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background: rgb(8, 20, 47);
      height: 100%;
      border-radius: 5px;
      filter: blur(25px);
      opacity: 0.5;
    }

    &.-active {
      opacity: 1;
    }
  }

  &__side {
    border-radius: 15px;
    overflow: hidden;
    // box-shadow: 3px 13px 30px 0px rgba(11, 19, 41, 0.5);
    // box-shadow: 0 1px 10px 0 rgba(14, 42, 90, 0.55);
    box-shadow: 0 1px 7px 0 rgba(14, 42, 90, 0.473);
    transform: perspective(2000px) rotateY(0deg) rotateX(0deg) rotate(0deg);
    transform-style: preserve-3d;
    transition: all 0.8s cubic-bezier(0.71, 0.03, 0.56, 0.85);
    backface-visibility: hidden;
    height: 100%;

    &.-back {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      transform: perspective(2000px) rotateY(-180deg) rotateX(0deg) rotate(0deg);
      z-index: 2;
      padding: 0;
      // background-color: #2364d2;
      // background-image: linear-gradient(
      //   43deg,
      //   #4158d0 0%,
      //   #8555c7 46%,
      //   #2364d2 100%
      // );
      height: 100%;
    }
  }
  &__bg {
    max-width: 100%;
    display: block;
    max-height: 100%;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  &__cover {
    position: absolute;
    height: 100%;
    background-color: #414141;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 15px;
    overflow: hidden;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      // background: rgba(6, 2, 29, 0.2);
    }
  }

  &__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 40px;
    padding: 0 10px;

    @media screen and (max-width: 480px) {
      margin-bottom: 25px;
    }
    @media screen and (max-width: 360px) {
      margin-bottom: 15px;
    }
  }

  &__chip {
    width: 60px;
    @media screen and (max-width: 480px) {
      width: 50px;
    }
    @media screen and (max-width: 360px) {
      width: 40px;
    }
  }

  &__type {
    height: 45px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    max-width: 100px;
    margin-left: auto;
    width: 100%;

    @media screen and (max-width: 480px) {
      height: 40px;
      max-width: 90px;
    }
    @media screen and (max-width: 360px) {
      height: 30px;
    }
  }

  &__typeImg {
    max-width: 100%;
    object-fit: contain;
    max-height: 100%;
    object-position: top right;
  }

  &__info {
    color: #fff;
    width: 100%;
    max-width: calc(100% - 85px);
    padding: 10px 15px;
    font-weight: 500;
    display: block;

    cursor: pointer;

    @media screen and (max-width: 480px) {
      padding: 10px;
    }
  }

  &__holder {
    opacity: 0.9;
    font-size: 13px;
    margin-bottom: 6px;
    @media screen and (max-width: 480px) {
      font-size: 12px;
      margin-bottom: 0px;
      margin-left: -70px;
    }
    @media screen and (max-width: 400px) {
      margin-left: -70px;
      margin-top: -10px;
    }
  }

  &__status {
    opacity: 0.9;
    font-size: 13px;
    margin-bottom: 6px;
    @media screen and (max-width: 480px) {
      font-size: 12px;
      margin-top: 10px;
      margin-left: 30px;
    }
    @media screen and (max-width: 400px) {
      margin-left: 40px;
      margin-top: 0px;
    }
  }

  &__wrapper {
    font-family: "Source Code Pro", monospace;
    padding: 25px 15px;
    position: relative;
    z-index: 4;
    height: 100%;
    text-shadow: 4px 2px 7px rgba(14, 42, 90, 0.461);
    // text-shadow: 7px 6px 10px rgba(14, 42, 90, 0.8);
    user-select: none;
    @media screen and (max-width: 480px) {
      padding: 20px 10px;
    }
    @media screen and (max-width: 320px) {
      left: -10px;
      padding: 0px 0px;
      // margin-bottom: 20px;
    }
  }

  &__name {
    font-size: 18px;
    line-height: 1;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }
  &__nameItem {
    display: inline-block;
    min-width: 8px;
    position: relative;
  }

  &__number {
    font-weight: 500;
    line-height: 1;
    color: #fff;
    font-size: 27px;
    margin-bottom: 35px;
    display: inline-block;
    padding: 10px 15px;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      font-size: 21px;
      margin-bottom: 15px;
      padding: 10px 10px;
    }
    @media screen and (max-width: 400px) {
      font-size: 19px;
      margin-bottom: 10px;
      padding: 10px 10px;
    }
    @media screen and (max-width: 360px) {
      font-size: 19px;
      margin-bottom: 10px;
      padding: 10px 10px;
    }
  }

  &__numberItem {
    width: 16px;
    display: inline-block;
    &.-active {
      width: 30px;
    }

    @media screen and (max-width: 480px) {
      width: 13px;

      &.-active {
        width: 16px;
      }
    }

    @media screen and (max-width: 360px) {
      width: 12px;

      &.-active {
        width: 8px;
      }
    }
  }

  &__content {
    color: #fff;
    display: flex;
    align-items: flex-start;
  }

  &__date {
    flex-wrap: wrap;
    font-size: 18px;
    margin-left: auto;
    padding: 10px;
    display: inline-flex;
    width: 80px;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: pointer;

    @media screen and (max-width: 480px) {
      font-size: 16px;
      margin-top: 0px;
      margin-left: -70px;
    }
    @media screen and (max-width: 400px) {
      font-size: 16px;
      margin-left: -70px;
      margin-top: -10px;
    }
  }

  &__dateItem {
    position: relative;
    width: 22px;
    display: inline-block;
    @media screen and (max-width: 480px) {
      font-size: 16px;
      margin-top: -5px;
    }
  }

  &__statusItem {
    font-size: 18px;
    line-height: 1;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;
    @media screen and (max-width: 480px) {
      font-size: 16px;
      margin-top: 0px;
    }
  }

  &__dateTitle {
    opacity: 0.9;
    font-size: 13px;
    padding-bottom: 6px;
    width: 100%;

    @media screen and (max-width: 480px) {
      font-size: 12px;
      padding-bottom: 5px;
    }
  }
  &__band {
    background: rgba(0, 0, 19, 0.8);
    width: 100%;
    height: 50px;
    margin-top: 30px;
    position: relative;
    z-index: 2;
    @media screen and (max-width: 480px) {
      margin-top: 20px;
    }
    @media screen and (max-width: 360px) {
      height: 40px;
      margin-top: 10px;
    }
  }

  &__cvv {
    text-align: right;
    position: relative;
    z-index: 2;
    padding: 15px;
    .card-item__type {
      opacity: 0.7;
    }

    @media screen and (max-width: 360px) {
      padding: 10px 15px;
    }
  }
  &__cvvTitle {
    padding-right: 10px;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    margin-bottom: 5px;
  }
  &__cvvBand {
    height: 45px;
    background: #fff;
    margin-bottom: 30px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    color: #1a3b5d;
    font-size: 18px;
    border-radius: 4px;
    box-shadow: 0px 10px 20px -7px rgba(32, 56, 117, 0.35);

    @media screen and (max-width: 480px) {
      height: 40px;
      margin-bottom: 20px;
    }

    @media screen and (max-width: 360px) {
      margin-bottom: 15px;
    }
  }
}
  .mobile-wrap {
    padding-left: 0!important;
    padding-right: 0!important;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    height: 612px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  // .mobile-wrap:before {
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   content: '';
  //   position: absolute;
  //   // background: rgba(90, 93, 165, .8);
  //   // background: linear-gradient(to bottom, rgba(90, 93, 165, 1), rgba(0, 0, 0, .7))
  // }
  .button {
    color: orange;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
  }
  .qrcode {
    width: 100vw;
    height: 300px ;
    // background-color: rgb(114, 114, 114);
  }
  .codearea {
    width: 90%;
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .list{
    text-align: left;
    height: 40px;
    width: 100%;
  }
  .list .item{
    margin-top: -5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    // border-bottom: 1px solid rgba(210, 210, 210, 0.815);
    height: 30px;
    padding: 5px;
  }
  .container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    box-sizing: border-box;
  }
  .container .list{
    text-align: left;
    height: 400px;
    width: 95vw;
  }
  .container .list .item{
    margin-top: 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    border-bottom: 1px solid rgba(210, 210, 210, 0.815);
    height: 50px;
    padding: 5px;
  }
  .container .list .item .title{
    color: rgba(0, 0, 0, 0.851);
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
  }
  .container .list .item .entitle{
    font-size: 13px;
    color: #ccc;
    margin-top: 7px;
  }


$primary-color:  #F57E28; //   #079ad9;
.radio-tile-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  //set dimensions for invisible container
  .input-container {
    position: relative;
    height:  4rem;
    width:  8rem;
    margin: 0.5rem;

    //make actual radio input invisible
    // + stretch to fill container
    .radio-button {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      margin: 0;
      cursor: pointer;
    }

    //default tile styles
    .radio-tile {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border: 2px solid $primary-color;
      border-radius: 5px;
      padding: 1rem;
      transition: transform 300ms ease;
    }
    .icon svg {
      fill: $primary-color;
      width: 2rem;
      height: 2rem;
    }
    .radio-tile-label {
      text-align: center;
      font-size: 0.9rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: $primary-color;
    }

    //active tile styles
    .radio-button:checked + .radio-tile {
      background-color: $primary-color;
      border: 2px solid $primary-color;
      color: white;
      transform: scale(1.1, 1.1);

      .icon svg {
        fill: white;
        background-color: $primary-color;
      }
      .radio-tile-label {
        color: white;
        background-color: $primary-color;
      }
    }
  }
}
</style>
